export const theme = {
  colors: {
    main: '#007787',
    main90: '#1A8593',
    main80: '#33929F',
    main70: '#4DA0AB',
    main60: '#66ADB7',
    main50: '#80BBC3',
    main40: '#99C8CF',
    main30: '#B3D6DB',
    main20: '#CCE3E7',
    main10: '#E6F1F3',

    darkMain: '#02363C',
    darkMain90: '#1A494E',
    darkMain80: '#325B60',
    darkMain70: '#497378',
    darkMain60: '#5F8A90',
    darkMain50: '#789FA4',
    darkMain40: '#90B3B8',
    darkMain30: '#BED1D4',
    darkMain20: '#EBEFF0',
    darkMain10: '#F5F7F8',

    accent: '#A9F4D4',
    accent90: '#B0F5D8',
    accent80: '#B7F6DC',
    accent70: '#C1F7E1',
    accent60: '#CBF7E5',
    accent50: '#D4F8E9',
    accent40: '#DCF8EC',
    accent30: '#E7F9F1',
    accent20: '#F2FAF6',
    accent10: '#F9FDFB',

    accent_dark: '#7ad5ad',
    accent_dark90: '#99edc8',
    accent_dark80: '#A9F4D4',
    accent_dark70: '#B0F5D8',
    accent_dark60: '#B7F6DC',
    accent_dark50: '#C1F7E1',
    accent_dark40: '#CBF7E5',
    accent_dark30: '#D4F8E9',
    accent_dark20: '#DCF8EC',
    accent_dark10: '#E7F9F1',

    warning_light: '#FDF7E7',
    warning_dark: '#B55806',
    warning_basic: '#F5A623',
    warning_support: '#FCE6C1',
    warning: '#F6D423',
    warning90: '#F7DD59',
    warning80: '#F7E58F',
    warning70: '#F7E89D',
    warning60: '#F7EAAB',
    warning50: '#F8EEBA',
    warning40: '#F8F1C9',
    warning30: '#FBF6DA',
    warning20: '#FDFAEA',
    warning10: '#FEFDF5',

    error_light: '#FFE7E8',
    error_dark: '#9F1E25',
    error_basic: '#E60D14',
    error_support: '#FCD1D3',
    error: '#CF2E45',
    error90: '#D34256',
    error80: '#D65567',
    error70: '#DA6979',
    error60: '#DD7D8A',
    error50: '#E1909C',
    error40: '#E4A3AD',
    error30: '#E8B7BF',
    error20: '#EBCBD0',
    error10: '#F5E5E8',

    success_dark: '#027411',
    success_basic: '#8BD8AD',
    success_support: '#CAE5BD',
    success_light: '#F1F7E6',
    success: '#8BD8AD',
    success90: '#95DBB4',
    success80: '#9FDDBA',
    success70: '#AAE0C2',
    success60: '#B5E3C9',
    success50: '#BFE6D0',
    success40: '#C9E8D6',
    success30: '#D4EBDE',
    success20: '#DEEDE5',
    success10: '#EFF6F2',

    lightGray: '#AEAEAE',
    lightGray90: '#B5B5B5',
    lightGray80: '#BBBBBB',
    lightGray70: '#C5C5C6',
    lightGray60: '#CECFD0',
    lightGray50: '#D8D9DA',
    lightGray40: '#E2E3E3',
    lightGray30: '#EDEDED',
    lightGray20: '#F7F7F7',
    lightGray10: '#FBFBFB',

    gray: '#555759',
    gray90: '#66686A',
    gray80: '#77787A',
    gray70: '#88898B',
    gray60: '#999A9B',
    gray50: '#AAABAC',
    gray40: '#BBBCBD',
    gray30: '#CCCDCE',
    gray20: '#DDDDDE',
    gray10: '#EEEEEF',

    violetPlus: '#54127D',
    violetPlus90: '#662B8B',
    violetPlus80: '#78449A',
    violetPlus70: '#8B5EA8',
    violetPlus60: '#9D77B7',
    violetPlus50: '#AF90C5',
    violetPlus40: '#C1A9D4',
    violetPlus30: '#D4C3E2',
    violetPlus20: '#E6DCF1',
    violetPlus10: '#F8F5FF',

    blue: '#00A8F3',
    white: '#FFFFFF',
    darkGray: '#47484A',
    black: '#000000',
    green: '#61932E',
    red: '#D0021B',
    mutuaAccent: '#FF0297',
    mutuaMain: '#0096D1',
    elParkingMain: '#007787',
    mutuaMain_dark: '#003893',
    googleRed: '#f44336',
    orange: '#EC6806',
    facebookBlue: '#405b8c',
    darkFacebookBlue: '#355089',
    transparent: 'transparent',

    mobility_support: '#F5C385',
    mobility_light: '#FCEDDA',
    mobility: '#F5A623',

    home_support: '#62B9AA',
    home_light: '#D0EAE6',
    home: '#38A491',

    finance_support: '#EF7F87',
    finance_light: '#FAD9DB',
    finance: '#E7535D',

    health_support: '#A499EB',
    health_light: '#E4E0F9',
    health: '#A584FF',

    focusColor: '#005eca',
  },
  decoration: {
    radius: '2px',
  },
  screens: {
    xSmall: '370px',
    small: '600px',
    medium: '768px',
    xLarge: '980px',
    xxLarge: '1025px',
    xxxLarge: '1200px',
  },
  screensMinMax: {
    xs: { max: '370px' },
    sm: { min: '371px', max: '600px' },
    md: { min: '601px', max: '768px' },
    lg: { min: '769px' },
  },
  font: {
    weights: {
      extralight: 100,
      light: 200,
      regular: 300,
      medium: 400, // Book
      book: 500, // Medium
      bold: 700,
      black: 800,
    },
    sizes: {
      xxxxLarge: '44px',
      xxxLarge: '36px',
      xxLarge: '24px',
      xLarge: '20px',
      large: '18px',
      medium: '16px',
      small: '14px',
      xSmall: '13px',
      xxSmall: '12px',
      xxxSmall: '10px',
    },
    lineHeight: {
      xxxxLarge: '1.2em',
      xxxLarge: '1.2em',
      xxLarge: '1.2em',
      xLarge: '1.2em',
      large: '1.2em',
      medium: '1.3em',
      small: '1.4em',
      xSmall: '1.4em',
      xxSmall: '1.4em',
      xxxSmall: '1.4em',
    },
  },
  gutter: 0,
  fontFamily: 'geomanist',
  components: {
    modal: {
      borderRadius: '0',
    },
    button: {
      borderRadius: '2px',
      minHeight: 'auto',
      textTransform: 'none',
      fontWeight: 'medium',
      fontSize: 'small',
      disabledBackgroundColor: 'gray20',
      hoverBackgroundColor: 'darkMain',
      hoverColor: 'white',
      activeBackgroundColor: 'gray',
      color: 'white',
      hoverBorderColor: 'transparent',
      backgroundColor: 'main',
      borderWidth: '0px',
      height: '40px',
      padding: '8px 20px',
    },
    buttonBordered: {
      borderWidth: '1px',
      borderColor: 'main',
      backgroundColor: 'white',
      color: 'main',
      hoverBackgroundColor: 'darkMain',
      hoverColor: 'white',
    },
    buttonUnstyled: {
      backgroundColor: 'transparent',
      disabledBackgroundColor: 'transparent',
      hoverBackgroundColor: 'transparent',
      fontSize: 'small',
      fontWeight: 'medium',
      color: 'main',
      hoverColor: 'main',
      padding: '0',
      height: 'auto',
    },
    input: {
      borderWidth: '1px',
      borderRadius: '2px',
      focusColor: 'main',
      fontSize: 'medium',
      fontWeight: 'regular',
      labelFontSize: 'xSmall',
      labelFontWeight: 'book',
    },
    simpleInput: {
      borderWidth: '0 0 1px 0',
      labelFontSize: 'xSmall',
      borderRadius: '0',
      focusColor: 'main',
      animated: true,
      paddingTop: 0,
    },
    paginatorButton: {
      backgroundColor: 'main',
      borderColor: 'main',
      borderRadius: '0px',
      enabledBorderColor: 'lightGray40',
    },
    table: {
      headerBackgroundColor: 'darkMain20',
      accent: 'main',
    },
    stepper: {
      main: 'main',
    },
    checks: {
      labelColor: 'gray',
      checkedColor: 'main',
      labelInside: {
        checkedBackgroundColor: 'accent10',
        disabledBackgroundColor: 'lightGray20',
        defaultBackgroundColor: 'white',
        checkedBorderColor: 'accent',
        disabledBorderColor: 'lightGray',
        defaultBorderColor: 'gray',
      },
      iconFilled: {
        disabledBackgroundColor: 'lightGray20',
        defaultBackgroundColor: 'white',
        disabledBorderColor: 'lightGray',
        defaultBorderColor: 'gray60',
        iconColor: 'main',
        defaultFontColor: 'gray',
      },
    },
    dropdown: {
      selectorOption: {
        hoverBackgroundColor: 'accent10',
      },
      selected: {
        padding: '0px 12px',
      },
    },
  },
  fontFaces: {
    geomanist: [
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-extralight-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-extralight-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 100,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-light-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-light-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 200,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-regular-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-regular-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 300,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-medium-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-medium-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 400,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-book-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-book-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 500,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-bold-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-bold-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 700,
        style: 'normal',
      },
      {
        urls: [
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-black-webfont.ttf',
            format: 'truetype',
          },
          {
            url: 'https://s3-eu-west-1.amazonaws.com/elparking-static/fonts/geomanist-black-webfont.woff',
            format: 'woff',
          },
        ],
        weight: 800,
        style: 'normal',
      },
    ],
  },
}

export const LINE_HEIGHT = Object.keys(theme.font.lineHeight)
export const FONT_SIZES = Object.keys(theme.font.sizes)
export const FONT_WEIGHTS = Object.keys(theme.font.weights)
export const COLORS = Object.keys(theme.colors)
